import type { TypeFormFieldElement } from '../../types/form';
import extractFieldValues from './extractFieldValues';

// ----------------------------------------------------------------------------

export type TypeSerializedObject = Record<string, string | string[]>;

// ----------------------------------------------------------------------------

function serializeObject(form: HTMLFormElement): TypeSerializedObject {
    const serialized: TypeSerializedObject = {};
    const elements = Array.from(form.elements) as TypeFormFieldElement[];

    for (const elField of elements) {
        const isAlwaysArray = elField instanceof HTMLSelectElement && elField.multiple;
        const values = extractFieldValues(elField);

        for (const { name, value } of values) {
            const currentValue = serialized[name];

            if (currentValue === undefined) {
                serialized[name] = isAlwaysArray ? [value] : value;
                continue;
            }

            if (Array.isArray(currentValue)) {
                currentValue.push(value);
            } else {
                serialized[name] = [currentValue, value];
            }
        }
    }

    return serialized;
}

// ----------------------------------------------------------------------------

export default serializeObject;
